// import axios from "axios";
// import { renewToken } from "../services/auth.service";
// import * as MyStorage from "./myStorage";
// import config from "../config";

// const ApiUrl = config().API_URL;
// const partnerUrl =config().PARTNER_URL;

// /**
//  * Setup a axios instance for whole application
//  * Here we setup basic config like API url and request headers
//  */
// const axiosInstance = axios.create({
//   baseURL: ApiUrl,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// });

// export const axiosPartnerInstance = axios.create({
//   baseURL: partnerUrl,
//   headers: {
//     "Accept": "application/json",
//     "Content-Type": "application/json",
//     "Connection-code": MyStorage.AppCache.getSelectedConnection()?.code || "",
//     jwt: (() => {
//       const accessToken = MyStorage.AppCache.getApplicationJwt();
//       const partnerToken = MyStorage.getServiceToken2(502);
//       return accessToken && partnerToken ? `${accessToken}.${partnerToken}` : "";
//     })(),
//   },
// });

// export const axiosPublicInstance = axios.create({
//   baseURL: ApiUrl,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// });

// export const axiosInstanceForMail = axios.create({
//   // baseURL: "https://mailtest.akead.link",
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     Jwt: MyStorage.getLinkForMail() || "",
//   },
// });

// /**
//  * Here we can handle API response and can modify
//  * before using it in React application or component
//  *
//  * @param {API Response} response
//  * @returns Promise
//  */
// const handleResponse = (response) => {
//   return new Promise((resolve) => {
//     const resData = response.data;
//     resolve(resData);
//   });
// };

// /**
//  * This function is used to handle failed API response
//  * Here we can refresh token
//  *
//  * @param {Object} error
//  * @returns
//  */
// const handleErrorResponse = async (error) => {
//   const { config, response } = error; // config artık kullanılacak
//   if (!response) return Promise.reject(error);

//   const resData = response.data;
//   if (response.status === 400 && resData.error.message === "Expired Jwt") {
//     MyStorage.removeToken();
//     window.location.href = "/authentication";
//     return Promise.reject("Session Expired");
//   }

//   // Token yenileme denemesi (örneğin, 401 hatası için)
//   if (response.status === 401) {
//     const token = MyStorage.AppCache.getApplicationJwt();
//     if (token && config) {
//       try {
//         const newToken = await renewToken({ oldJwt: token });
//         MyStorage.AppCache.setApplicationJwt(newToken.jwt);
//         config.headers["application-jwt"] = newToken?.jwt; // Header'ı güncelle
//         return axiosInstance(config); // Yeniden deneme
//       } catch (renewError) {
//         MyStorage.removeToken();
//         window.location.href = "/authentication";
//         return Promise.reject("Token renewal failed");
//       }
//     }
//   }

//   return Promise.reject(resData);
// };

// const handlePublicErrorResponse = async (error) => {
//   const { response } = error; // config kullanılmıyor, sadece response alınıyor
//   if (!response) return Promise.reject(error);
//   const resData = response.data;
//   return Promise.reject(resData);
// };

// /**
//  * We can intercept the outgoing Rest API request data here
//  * We can include headers or can modify request body
//  *
//  * @param {Request} req
//  * @returns
//  */
// const handleRequest = async (req) => {
//   if (
//     req.url !== "/Membership/login" &&
//     req.url !== "/Membership/renewToken" &&
//     req.url !== "/Membership/renewPasswordMail"
//   ) {
//     try {
//       const res = await renewToken({ oldJwt: MyStorage.AppCache.getApplicationJwt() });
//       if (res?.jwt) {
//         MyStorage.AppCache.setApplicationJwt(res.jwt);
//         setTimeout(() => {
//           const channel = new BroadcastChannel("myChannel");
//           channel.postMessage("new token");
//         }, 1000);
//       }
//     } catch (error) {
//       console.error("Token yenileme hatası:", error);
//     }
//   }

//   let headers = req.headers;
//   if (
//     req.url.includes("Membership") &&
//     req.url !== "/Membership/login" &&
//     req.url !== "/Membership/renewToken" &&
//     req.url !== "/Membership/renewPasswordMail"
//   ) {
//     const accessToken = MyStorage.AppCache.getApplicationJwt();
//     if (accessToken) headers["application-jwt"] = accessToken;
//   }

//   if (req.url.includes("Admin")) {
//     const accessToken = MyStorage.AppCache.getApplicationJwt();
//     const serviceToken = MyStorage.getServiceToken2(11)?.jwt;
//     if (accessToken && serviceToken)
//       headers["jwt"] = `${accessToken}.${serviceToken}`;
//   }

//   req.headers = headers;
//   return req;
// };

// // Handle request error
// const handleRequestError = (error) => {
//   return Promise.reject(error);
// };

// // Request Interceptor
// axiosInstance.interceptors.request.use(handleRequest, handleRequestError);
// axiosPartnerInstance.interceptors.request.use(handleRequest, handleRequestError);

// axiosInstanceForMail.interceptors.request.use(handleRequest, handleRequestError);

// // Response Interceptor
// axiosInstance.interceptors.response.use(handleResponse, handleErrorResponse);
// axiosPartnerInstance.interceptors.response.use(handleResponse, handleErrorResponse);
// axiosInstanceForMail.interceptors.response.use(handleResponse, handleErrorResponse);


// axiosPublicInstance.interceptors.request.use((req) => {
//   let token = MyStorage.getAccessToken();
//   let headers = req.headers;
//   if (

//     req.url.includes("Membership") &&
//     req.url !== "/Membership/login" &&
//     req.url !== "/Membership/renewToken" &&
//     req.url !== "/Membership/renewPasswordMail"
//   ) {
//     if (token) headers["application-jwt"] = token;
//   }
//   return req;
// }, handleRequestError);

// axiosPublicInstance.interceptors.response.use(
//   handleResponse,
//   handlePublicErrorResponse
// );

// export default axiosInstance;


import axios from "axios";
import config from "../config";

const ApiUrl = config().API_URL;
const partnerUrl = config().PARTNER_URL;

const axiosInstance = axios.create({
  baseURL: ApiUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const axiosPartnerInstance = axios.create({
  baseURL: partnerUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const axiosPublicInstance = axios.create({
  baseURL: ApiUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const handleResponse = (response) => {
  return Promise.resolve(response.data);
};

const handleErrorResponse = (error) => {
  const resData = error.response?.data || error;
  return Promise.reject(resData);
};

const handleRequestError = (error) => Promise.reject(error);

// Request ve Response interceptors (login yok, token yok)
axiosInstance.interceptors.response.use(handleResponse, handleErrorResponse);
axiosPartnerInstance.interceptors.response.use(handleResponse, handleErrorResponse);
axiosPublicInstance.interceptors.response.use(handleResponse, handleErrorResponse);

export default axiosInstance;
